module.exports = __webpack_public_path__ + "static/media/Roboto-BoldCondensed.2f89fa2a.ttf";